module.exports = __webpack_public_path__ + "img/E-swar-logo.50a7b031.png";